import { INewFacility } from 'apps/fleet-planner/schema/FacilitySchema'
import { ICustomerContact } from 'apps/fleet-planner/types'
import { IFacilityAddress } from 'apps/fleet-planner/utils/api/facilities'

/**
 * Get a usable object for default form values.
 * This uses `??` operator to remove `null` values completely
 */
export const getFacilityDefaultValues = (
  name: string = '',
  address: Partial<IFacilityAddress> = {},
  contact: Partial<ICustomerContact> = {}
): INewFacility => {
  const { addressLine1, addressLine2, addressee, locality, postalCode, subdivisionCode } =
    address || {}
  const { email, name: contactName = '', phone, phoneExt } = contact || {}

  return {
    name: name ?? '',
    address: {
      addressee: addressee ?? '',
      addressLine1: addressLine1 ?? '',
      addressLine2: addressLine2 ?? '',
      postalCode: postalCode ?? '',
      location: {
        subdivisionCode: subdivisionCode ?? '',
        locality: locality ?? '',
      },
    },
    contact: {
      name: contactName ?? '',
      email: email ?? '',
      phone: phone ?? '',
      phoneExt: phoneExt ?? '',
    },
  }
}
